var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorModeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.311a5.311 5.311 0 100-10.622zm7.1-2.365v4.149h-4.154L12 21.995l-2.946-2.9h-4.15v-4.149L2.004 12l2.9-2.946v-4.15h4.15L12 2.004l2.946 2.9h4.149v4.15l2.9 2.946z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15051",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgColorModeIcon;